import actionCable from 'actioncable';
import { default as config } from './config';

class ActionCable {
  constructor(actionCableServer, mount) {
    const server = config.serverUrl[actionCableServer];
    this.consumer = actionCable.createConsumer(server + mount);
  }

  subscribe(channel, data, received) {
    const channelData = data || {};
    this.consumer.subscriptions.create(
      { ...channelData, channel },
      { received }
    );
  }
}

export default ActionCable;
